import { LoadingCircleAnimation } from '~/assets';
import { CreditLimit, If, SceneWrapper } from '~/components';
import { currencyParser, observer } from '~/modules';
import {
  ButtonComponent,
  Description,
  LoadingContainer,
  LoadingIndicator,
  Title,
} from './styles';

type CreditSimulationWithdrawalConfirmationProps = {
  isChecking: boolean;
  isAuthorizing: boolean;
  authorizeWithdraw: () => void;
  pendingWithdrawal: Withdrawal | null;
};

const CreditSimulationWithdrawalConfirmation: React.FC<
  CreditSimulationWithdrawalConfirmationProps
> = ({ isChecking, isAuthorizing, authorizeWithdraw, pendingWithdrawal }) => {
  const getFooter = () => {
    return (
      <ButtonComponent
        id="btn-simulation-confirmation"
        onPress={authorizeWithdraw}
        onLoading={isAuthorizing}
      >
        CONFIRMAR SAQUE
      </ButtonComponent>
    );
  };
  return (
    <SceneWrapper footer={isChecking ? null : getFooter()}>
      <If condition={isChecking}>
        <LoadingContainer>
          <LoadingIndicator
            options={{ animationData: LoadingCircleAnimation }}
          />
          <Title>Aguardando confirmação do saque...</Title>
          <Description>
            Estamos verificando o status do seu saque. Por favor, aguarde um
            momento.
          </Description>
        </LoadingContainer>
      </If>
      <If condition={!isChecking}>
        <Title>Confirmação de saque</Title>
        <Description>Confira abaixo os detalhes do seu saque</Description>
        <CreditLimit
          title="Valor solicitado"
          value={currencyParser(pendingWithdrawal?.amount?.toString() || '')}
        />
      </If>
    </SceneWrapper>
  );
};

export default observer(CreditSimulationWithdrawalConfirmation);
